"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var idGenerator_1 = require("spry-react/utils/idGenerator");
require("spry-react/utils/react-ext");
require("./radioButtonField.less");
var RadioButtonField = /** @class */ (function (_super) {
    __extends(RadioButtonField, _super);
    function RadioButtonField(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            _this.props.onChange(_this.props.value);
        };
        _this.state = {
            id: props.id || idGenerator_1.GenerateId()
        };
        return _this;
    }
    RadioButtonField.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: "radio-field", title: this.props.title },
            React.createElement("input", { type: "radio", id: this.state.id, disabled: this.props.disabled, value: this.props.value, checked: this.props.checked, onChange: function () { return _this.props.onChange(_this.props.value); } }),
            React.createElement("label", { htmlFor: this.state.id, disabled: this.props.disabled }, this.props.label));
    };
    return RadioButtonField;
}(React.Component));
exports.RadioButtonField = RadioButtonField;
